import { useState, useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import CommunityMirrors from "./CommunityMirrors";
import { getCommunityMirrors } from "../../api";

const CommunityMirrorsContainer = () => {
  const [projects, setProjects] = useState<CommunityMirrorProject[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const toast = useToast();

  useEffect(() => {
    const fetchCommunityMirrors = async () => {
      try {
        const data = await getCommunityMirrors();
        setProjects(data);
      } catch (error) {
        setError("Failed to fetch community mirrors");
        toast({
          title: "Error",
          description: "Failed to fetch community mirrors",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchCommunityMirrors();
  }, [toast]);

  return (
    <CommunityMirrors projects={projects} isLoading={isLoading} error={error} />
  );
};

export default CommunityMirrorsContainer;
